import React from "react";
import styled from "styled-components";
import {
    Toast,
    LottieLoadingIndicator,
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalSection,
    StandardModalSectionTitle,
    StandardModalText,
} from "src/components";

import EmployeeDocumentUploader from "src/scenes/EmployeeList/components/Documents/EmployeeDocumentUploader";
import { EMPLOYEE_MODE_SOURCE } from "src/scenes/EmployeeList/components/Documents/utils";

import {
    uploadDocuments,
} from "src/components/Documents/api/documentsApi";

const SmallLoader = styled.div`
    width: 40px;
    height: 40px;

    display: flex;
    align-items: center;
    justify-content: center;

    svg, div {
        width: 40px !important;
        height: 40px !important;
    }
`;

export default function EmployeeRequiredDocumentsModal({
    open,
    onClose,
    businessName,
    requiredDocuments = [],
    headerTitle = "Required Documents",
    onSubmitted,
}) {
    const [documents, setDocuments] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    if (!open) return null;

    const hasFilesToUpload = documents?.some(
        doc => doc && !doc?.uploaded
    );

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const filesToUpload = documents?.map(doc =>
                doc instanceof File ? doc : null
            );

            await uploadDocuments({
                requiredDocuments,
                documents: filesToUpload,
            });

            Toast.success("Documents uploaded successfully");
            onSubmitted?.();
            onClose?.();
        } catch (err) {
            console.error(err);
            Toast.error("Failed to upload documents");
        } finally {
            setLoading(false);
        }
    };

    return (
        <StandardModal
            open={open}
            onClose={onClose}
            title={headerTitle}
            description={`Your account setup is almost complete. Please upload the required documents requested by ${businessName} below. Each document must be uploaded individually under its matching title.`}
            widthMode="large"
            footer={(
                <StandardModalActionGroup $pushRight>
                    <StandardModalActionButton
                        onClick={onClose}
                        border="1px solid #171A22"
                        color="#171A22"
                    >
                        Close
                    </StandardModalActionButton>
                    <StandardModalActionButton
                        $variant="primary"
                        onClick={handleSubmit}
                        disabled={loading || !hasFilesToUpload}
                        backgroundColor={!hasFilesToUpload ? "#B9B9B9" : "#171A22"}
                        border={!hasFilesToUpload ? "1px solid #B9B9B9" : "1px solid #171A22"}
                        minWidth="154px"
                    >
                        {loading ? (
                            <SmallLoader>
                                <LottieLoadingIndicator />
                            </SmallLoader>
                        ) : (
                            "Submit Documents"
                        )}
                    </StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalSectionTitle>Documents Needed</StandardModalSectionTitle>
                <EmployeeDocumentUploader
                    requiredDocuments={requiredDocuments}
                    title="Documents Needed"
                    mode={EMPLOYEE_MODE_SOURCE.DASHBOARD}
                    color="#171A22"
                    onChange={({ documents }) => {
                        setDocuments(documents);
                    }}
                />
            </StandardModalSection>

            <StandardModalText color="#8E4EB4">
                All required documents must be submitted before your account can be finalised.
            </StandardModalText>
        </StandardModal>
    );
}
